import styled, { css } from 'styled-components';

export const LearnMoreModalListContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km4};
  `}
`;

interface IProps {
  $customColumnNumber: number;
}

export const LearnMoreModalLogoListContainer = styled.div<IProps>`
  ${({ theme: { spacing }, $customColumnNumber }) => css`
    width: 25rem;
    display: grid;
    justify-items: center;
    align-items: center;
    grid-template-columns: repeat(5, 1fr);
    grid-auto-rows: 2rem;
    grid-gap: ${spacing.km4} ${spacing.km5};

    ${$customColumnNumber &&
    css`
      grid-template-columns: repeat(${$customColumnNumber}, 1fr);
      width: auto;
      img {
        height: auto;
      }
    `}
  `}
`;

export const FeaturesList = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 100%;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km8};
  `}
`;

export const FeatureItem = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-template-columns: 1.5rem auto;
    grid-auto-rows: max-content;
    grid-gap: ${spacing.km3};
  `}
`;
